import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

@IonicPage()
@Component({
  selector: 'page-cronos-file',
  templateUrl: 'cronos-file.html',
})
export class CronosFilePage {

  public title: string;
  public type: string;
  public url: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public sanitizer: DomSanitizer) {
  }

  ionViewDidLoad() {
    if (this.navParams.data) {
      this.title = this.navParams.data.filename;
      this.type = this.navParams.data.type;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.navParams.data.url);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-file/cronos-file.ts